import { TemplateRef, ViewContainerRef } from '@angular/core';

export abstract class PgTemplatePageHost {
  abstract getPages();
  abstract getSectionTitle();
}

export abstract class PgTemplatePage {
  abstract get key(): string;
  abstract get templateRef(): TemplateRef<any>;
  abstract get viewContainerRef(): ViewContainerRef;
}
